import { Grid, Paper } from "@material-ui/core";
import { vendorDashStyle } from "../style";
import { GraphLoader } from "../GraphLoader";
import ShimmerLoader from "components/ShimmerLoader/ShimmerLoader";

export const TopPerformingVendorsWidget = ({ data, isFetching, isLoading }) => {
    const classes = vendorDashStyle();
    return (
        <Paper className={classes.card}>
            <Grid container direction="column" spacing={1}>
                {!!data?.topPerformingVendors?.length && <><Grid item>
                    Top Performing Vendors
                </Grid>
                    <Grid item container spacing={1}>
                        {isLoading && <ShimmerLoader count={3} height="100" width={3} />}
                        {data?.topPerformingVendors?.map(v => <VendorItem key={v.vendorId} vendor={v} />)}
                    </Grid></>}
                <Grid item>
                    Vendors Needing Attention
                </Grid>
                <Grid item container spacing={1}>
                    {isLoading && <ShimmerLoader count={3} height="100" width={3} />}
                    {data?.vendorsNeedingAttention?.map(v => <VendorItem key={v.vendorId} vendor={v} />)}
                </Grid>
            </Grid>
            <GraphLoader loading={isFetching} />
        </Paper>
    )
}

const VendorItem = ({ vendor }) => {
    const classes = vendorDashStyle();
    return (
        <Grid item xs={4}>
            <Paper className={classes.vendorCard}>
                <Grid container direction="column" spacing={1}>
                    <Grid justifyContent="space-between" item className={classes.vendorName} spacing={1} container>
                        <Grid item className={classes.vendorName}>{vendor.vendorName}</Grid>
                        <Grid item className={classes.vendorScore}>
                            {vendor.overallScore.toFixed(2)}
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
        </Grid>)
}